import { WidgetTabOverrideService } from './widget-tab-override.service';
import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class WidgetLayoutService {
  tab_service = new WidgetTabOverrideService();
  card_column_class = 'card-column';
  widget_holder: ViewContainerRef;
  widget_anchor: ViewContainerRef;

  setParentContainers(widgetHolder: ViewContainerRef, widgetAnchor: ViewContainerRef) {
    this.widget_holder = widgetHolder;
    this.widget_anchor = widgetAnchor;
  }

  currentColumnCount() {
    return this.widget_holder.element.nativeElement.getElementsByClassName(this.card_column_class).length;
  }

  clear(widgetElements: Array<HTMLElement>) {
    // move back widgets DOM elements to anchor before clearing container
    // to fix issue in IE11 where widget DOM become empty after clear container
    for (let i = 0; i < widgetElements.length; i++) {
      this.widget_anchor.element.nativeElement.appendChild(widgetElements[i]);
    }

    this.widget_holder.element.nativeElement.innerHTML = '';
  }

  arrangeWidgets(widgetElements: Array<HTMLElement>, columnCount: number, bindEventListener = true) {
    this.clear(widgetElements);

    // build a certain number of columns depending on the widget of the page
    const column_elements = this.buildColumns(columnCount);
    column_elements.forEach(element => {
      this.widget_holder.element.nativeElement.appendChild(element);
    });

    // the tab service needs a list of all widgets for reference
    this.tab_service.setWidgetsList(widgetElements);
    // loop through list of widget DOM elements and distribute to columns
    for (let i = 0; i < widgetElements.length; i++) {
      // get widget
      const widget_element = widgetElements[i];

      // get the height of all the columns at this current moment
      const colheights = [];

      for (let cc = 0; cc < columnCount; cc++) {
        colheights.push(column_elements[cc].clientHeight);
      }

      // find the index of the shortest column
      const smallest_col_index = colheights.indexOf(Math.min(...colheights));

      // now add the element to the shortest
      column_elements[smallest_col_index].appendChild(widget_element);

    }

  }

  // calculates the number of columns needed depending on the screen size
  numberOfColumnsForBrowserWidth(browserWidth: number) {
    const breakpoints = { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 };
    if (browserWidth >= breakpoints.xl) {
      return 4;
    }

    if (browserWidth < breakpoints.xl && browserWidth >= breakpoints.lg) {
      return 3;
    }

    if (browserWidth < breakpoints.lg && browserWidth >= breakpoints.md) {
      return 2;
    }

    return 1;
  }

  // builds the columns based on the current screen size
  private buildColumns(numberOfColumns: number) {
    const column_elements = [];

    for (let i = 0; i < numberOfColumns; i++) {
      const element = document.createElement('div');
      element.className += this.columnCssClass(numberOfColumns);
      element.id = `card-col-${i}`;

      column_elements.push(element);
    }

    return column_elements;
  }

  // gets the CSS class to be used for the columns depending on the screen size
  private columnCssClass(numberOfColumns: number) {
    const bootstrap_classes = {
      1: 'col-xs-12',
      2: 'col-sm-6',
      3: 'col-md-4',
      4: 'col-lg-3'
    };

    const bootstrap_class_name = bootstrap_classes[numberOfColumns] || bootstrap_classes[4];
    return `${this.card_column_class} ${bootstrap_class_name}`;
  }
}



// WEBPACK FOOTER //
// ./app/services/widget/widget-layout.service.ts